<template>
  <div class="wait">
    <el-form ref="waitForm" :model="waitForm" :rules="waitFormRules" style="padding-right: 10px">
      <el-form-item class="text-align-left" label="等待详情:" :label-width="addLabelWidth">
        <template>
          <el-radio-group @change="changeWaitType" v-model="waitForm.waitType">
            <el-radio :label="0" style="margin-left: 0;">等待时长</el-radio>
            <el-radio :label="1" style="margin-left: 10px;">等待至指定时间</el-radio>
          </el-radio-group>
        </template>
      </el-form-item>
      <el-form-item v-if="waitForm.waitType === 0" prop="day" label="时长:" label-width="70px" class="stockInputs">
        <el-input-number
          class="timeInput"
          @change="update"
          :min="1"
          :max="10000000000000"
          controls-position="right"
          v-model="waitForm.day">
        </el-input-number>
        天
        <el-input-number
          class="timeInput"
          @change="update"
          :min="1"
          :max="24"
          controls-position="right"
          v-model="waitForm.hours">
        </el-input-number>
        小时
        <el-input-number
          class="timeInput"
          @change="update"
          :min="1"
          :max="60"
          controls-position="right"
          v-model="waitForm.mins">
        </el-input-number>
        分钟
      </el-form-item>
      <el-form-item v-if="waitForm.waitType === 1" prop="confirmTime" class="text-align-left" label="具体时刻:" :label-width="addLabelWidth">
        <el-date-picker
          v-model="waitForm.confirmTime"
          @change="update"
          type="datetime"
          placeholder="选择日期时间">
        </el-date-picker>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
export default {
  name: '',
  props: ['contents'],
  data () {
    return {
      waitFormRules: {
        day: [
          { required: true, message: '具体时刻不能为空', trigger: 'change' }
        ],
        confirmTime: [
          { required: true, message: '具体时刻不能为空', trigger: 'change' }
        ]
      },
      addLabelWidth: '90px',
      waitForm: this.contents,
      search: {
        status: 2
      },
      page: 1
    }
  },
  computed: {
  },
  methods: {
    // 传值到父组件
    update() {
      // 获取几天后的时间戳
      let timeStamp = parseInt(new Date(new Date().getTime()) / 1000)
      let xTimesAfter = 0
      xTimesAfter = timeStamp + 86400 * parseInt(this.waitForm.day) + 3600 * parseInt(this.waitForm.hours) + 60 * parseInt(this.waitForm.mins)
      // 获取指定时间的时间戳
      let timeSet = parseInt(new Date(new Date().setTime(this.waitForm.confirmTime)) / 1000)
      // 传值到父组件
      let choose = {}
      choose.id = this.waitForm.id
      choose.nodeType = 'waitNode'
      choose.waitType = this.waitForm.waitType
      choose.day = this.waitForm.day
      choose.hours = this.waitForm.hours
      choose.mins = this.waitForm.mins
      choose.confirmTime = this.waitForm.confirmTime
      if (this.waitForm.waitType === 0) {
        choose.relatime = xTimesAfter
      } else {
        choose.relatime = timeSet
      }
      console.log('choose.relatime', choose.relatime)
      this.$emit('getWait', choose)
    },
    changeWaitType() {
      this.waitForm.day = 0
      this.waitForm.hours = 0
      this.waitForm.mins = 0
      this.waitForm.confirmTime = ''
      this.update()
    }
  },
  watch: {
    contents: function (val) {
      this.waitForm = val
      console.log('contents', val)
    }
  },
  created() {
    console.log(this.waitForm, this.contents)
  }
}
</script>

<style scoped>
</style>
